import axios from 'axios';
import { triggerAccessDenied } from '../utils/accessDenied';
import { getLoadingContext } from '../context/LoadingContext';

const api = axios.create({
  //baseURL: 'http://localhost:3000',
  //baseURL: 'https://testapi.nicoarch.xyz',
  baseURL: 'https://main.crystalmultiservices.com'
});

// REQUEST
api.interceptors.request.use(
  (config) => {
    config.__showLoading = !config.skipGlobalLoading;

    if (config.__showLoading) {
      const ctx = getLoadingContext();
      ctx?.start?.();
    }

    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    const ctx = getLoadingContext();
    ctx?.stop?.();
    return Promise.reject(error);
  }
);

// RESPONSE
api.interceptors.response.use(
  (res) => {
    if (res.config?.__showLoading) {
      const ctx = getLoadingContext();
      ctx?.stop?.();
    }
    return res;
  },
  (err) => {
    if (err.config?.__showLoading) {
      const ctx = getLoadingContext();
      ctx?.stop?.();
    }
    if (err.response?.status === 403) {
      triggerAccessDenied();
    }
    return Promise.reject(err);
  }
);

export default api;